export enum Day {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}

export interface DayAbbreviation {
  day: Day;
  abbreviation: string;
}

export interface Session {
  sessionId: number;
  accountId: number;
  programId: number;
  sessionName: string;
  programName: string;
  note1: string;
  note2: string;
  startDateTime: string;
  endDateTime: string;
  selectedDays: Array<Day>;
  enrollmentCount: number;
  scholarCapacity?: number;
  autoEnroll: boolean;
  autoEnrollment: string;
  autoEnrollCapacity?: number;
  waitListCapacity?: number;
  isTimeAdded: boolean;
  ageAsOf: string;
  ageFrom?: number;
  ageTo?: number;
  ageRestriction: string;
  createdAt: string;
  status: number;
  siteLocationId?: number;
  siteLocation?: VerifiedSiteLocation;
  waitlistCount: number;
  selected?: boolean;
}

export interface VerifiedSiteLocation {
  id: number;
  siteLocationName: string;
  location: VerifiedLocation;
}

export interface VerifiedLocation {
  id: number;
  locationVerifiedId: number;
  addressLine1: string;
  addressLine2: string;
  city: string;
  stateCode: string;
  zip5: string;
  zip4: string;
  county: string;
  country: string;
  latitude: number;
  longitude: number;
  addressHash: string;
  status: number;
  createdAt: Date;
}

export interface SiteLocationAddress {
  siteLocationId?: number;
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zip: string;
}

export interface Auth0Token {
  aud: string[];
  azp: string;
  bxtoken: string;
  deviceID: string;
  exp: number;
  iat: number;
  isBxPortal: boolean;
  isFamilyPortal: boolean;
  iss: string;
  mobileDevice: string;
  roleId: string;
  rolePermissionAccount: string;
  rolePermissionProgram: string;
  rolePermissionSite: string;
  scope: string;
  secret: string;
  sub: string;
  tokenId: string;
  userId: string;
  userRoles: IUserRole[];
}

export interface IUserRole {
  id: number;
  roleId: number;
  userId: number;
  accountId: number;
  programId: number;
  siteId: number;
  isPrimaryAccountAdmin: false;
  status: number;
  userRoleClassrooms?: IUserRoleClassRoom[];
  programRole?: string;
}
export interface IUserRoleClassRoom {
  id: number;
  userRoleId: number;
  classRoomId: number;
  classRoomName: string;
}
